import { render } from "./ResetPassword.vue?vue&type=template&id=5d9a3708"
import script from "./ResetPassword.js?vue&type=script&lang=js"
export * from "./ResetPassword.js?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__